'use strict';

define('fastActionUser',['fastaction_config', 'backbone', 'deviceInfo', 'cookieConsentConfiguration'],
  function (fastaction, Backbone, deviceInfo, cookieConsentConfig) {
    var $ = Backbone.$;
    var _ = Backbone._;
    return (new (Backbone.Model.extend({
      __name__: 'FastActionUser',
      initialize: function () {
        _.bindAll(this, 'fetch', 'clear', 'onSyncError', 'loginAndFetchProfile');
      },
      name: function () {
        var name = '', get = this.get('profiles');
        if (get) {
          if (get.facebook) {
            return get.facebook.name;
          }
          if (get.twitter) {
            return get.twitter.name;
          }
          if (get.actionid) {
            name = get.actionid.displayName;
            // Users registering through the fastAction workflow get a displayName that is
            // all whitespace.  Since we only have an email address from them, use that.
            if (!name || /^\s*$/.test(name)) {
              name = get.actionid.emails[0].value;
            }
          }
        }
        return name;
      },
      onSyncError: function (model, response, options) {
        this.trigger('syncError', model, response, options);
      },
      url: function () {
        return fastaction.urls.profile(this.get('id'));
      },
      fetch: function (options) {
        options = options || {};
        options.cache = deviceInfo.ie ? false : options.cache || false;
        var self = this,
          deferred = $.Deferred();

        if (cookieConsentConfig.areFunctionalCookiesAccepted()) {
          var identity = $.jsonp({
              cache: options.cache,
              url: fastaction.urls.identity()
            });

        identity.then(function (resp, status, jqXHR) { // jshint ignore:line
          var sessionID = resp.fastActionSessionId;
          var DNT = resp.dnt && (!deviceInfo.ie || deviceInfo.version !== '10');
          if (sessionID) {
            self.set('fastActionSessionId', sessionID);
          }
          self.set('dnt', DNT);
          if (DNT) {
            $('.at input[name="updateMyProfile"]').prop('checked', false);
          }
          if (resp.id) {
            self.set('id', resp.id);
            self.set('authed', resp.authed || false);

            options.error = self.onSyncError;
            options.xhrFields = { withCredentials: true };

            // Fetching profile and assigning to attributes
            Backbone.Model.prototype.fetch.call(self, options).then(deferred.resolve, deferred.reject);
          } else {
            if (options.clear) {
              _.invoke(window.nvtag.data, 'clear');
              self.logout();
            }
            deferred.reject(self, identity, 'error', 'Unauthorized');
          }
        }, _.partial(deferred.reject, self));
        } else {
          deferred.reject('Functional cookies not accepted');
        }

        return deferred.promise();
      },
      clear: function () {
        _.each(this.attributes, function (val, key) {
          if (key !== 'fastActionSessionId' && key !== 'dnt') {
            this.unset(key);
          }
        }, this);
        return this.trigger('clear');
      },
      logout: function () {
        return this.trigger('logout').clear();
      },
      loginAndFetchProfile: function (id) {
        var options = {
          url: fastaction.urls.loginProfile(id),
          cache: false,
          xhrFields: { withCredentials: true },
          error: this.onSyncError
        };

        // Fetch new properties for id and assign to attributes (including id)
        return Backbone.Model.prototype.fetch.call(this, options);
      }
    }))());
  });

